/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ContractApi from '@/api/contract';
import { ConstractPreApply } from '@/api/contract/types';
import { ALIPAYMINI_COMMODITY, NEW_YINHE_COMMODITY } from '@/shared/commodity';
import platform from '@/shared/utils/platform';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NewYHConstract extends Vue {
  protected constractForms: ConstractPreApply = {
    contractNo: '',
    effectiveDate: '',
    funderName: '',
    idCard: '',
    productName: '',
    userName: '',
    funderCode: '',
  };

  protected get constractForm(): ConstractPreApply {
    return this.constractForms && this.constractForms;
  }

  protected get funderCode() {
    return this.constractForms.funderCode && [
      'HANGYIN',
    ].indexOf(this.constractForms.funderCode) >= 0;
  }

  private async created() {
    await this.getConstract();
  }

  protected async getConstract(): Promise<void> {
    // 支付宝小程序和App中的银河渠道使用两个不同的commodityId，避免出现初筛记录不存在的问题
    const commodityId = Number(platform.isAlipayMini ? ALIPAYMINI_COMMODITY : NEW_YINHE_COMMODITY);

    this.constractForms = await ContractApi.newYhConstract({
      commodityId,
      loanOrderId: '',
      repayStatus: '',
    });
  }
}
